// const REPORT_BASE_URL = `https://localhost:44378/Report`;
// const REPORT_BASE_URL = `https://report.barassociationdehradun.com/Report`;
const REPORT_BASE_URL =
  process.env.NODE_ENV === "production"
    ? `https://report.barassociationdehradun.com/Report`
    : `https://localhost:44378/Report`;

export default REPORT_BASE_URL;
